import { ca } from '@cian/analytics';
import { IAnalyticsProduct } from '../../../../shared/ServicePickerWidget/types/analytics';

export const trackPayByCardModalOpen = (analyticsProduct: IAnalyticsProduct) => {
  ca('eventSite', {
    name: 'oldevent',
    // Пока размещаем такую ФВУ только на новой ФП, прописываем создание объявления
    // дальше нужно будет как-то получать данные извне или вынести в addform-bdui-frontend
    category: 'New_ad',
    action: 'not_enough_money_popup_open',
    label: 'add_offer',
    page: {
      pageType: 'NewAddForm',
    },
    products: [analyticsProduct],
  });
};
